import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetBackOfficeTotalsByInstallationReqData } from "./GetBackOfficeTotalsByInstallationReqData";
import { GetBackOfficeTotalsByInstallationResData } from "./GetBackOfficeTotalsByInstallationResData";

const ENDPOINT = "/cash_flow/back_office_totals_by_installation"

export class GetBackOfficeTotalsByInstallationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetBackOfficeTotalsByInstallationReqData = null;

    constructor(params: GetBackOfficeTotalsByInstallationReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetBackOfficeTotalsByInstallationResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetBackOfficeTotalsByInstallationResData(res);
    }

}